import React, {Component} from 'react';
import Api from "../../utils/Api";
import moment from 'moment';
import PropTypes from "prop-types";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import TimeRange from "../../utils/TimeRange";
import ZSKPieChart from "../../utils/charts/ZSKPieChart";
import MachineStates from "../../utils/MachineStates";
import StaticFunctions from "../../utils/StaticFunctions";

class PreviewReportMachinePerformance extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.object.isRequired,
        height: PropTypes.number
    };

    static defaultProps = {
        header: 'Machine Performance',
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        let tr = new TimeRange();
        let from = moment().subtract(14, 'days');

        tr.setRange(from, moment());

        this.state = {
            timeRange: tr, // TimeRange
            requestedParams: null, // stringified parameters to prevent double-request
            chartAreaWidth: null,
            chartData: null // chartdata from server
        };

        this.translate = this.props.baseData.translate;
        this.resizeTimer = null;

        this.domRef = React.createRef();

        this.updateDimensions = this.updateDimensions.bind(this);
        this.requestReport = this.requestReport.bind(this);

        this.generateLegend = this.generateLegend.bind(this);
        this.getTableRows = this.getTableRows.bind(this);
    };

    componentWillMount() {

        // Stitches laden
        this.requestReport();

    }

    componentDidMount() {

        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions);

    }

    componentWillUnmount() {

        window.removeEventListener("resize", this.updateDimensions);

    }

    updateDimensions() {

        let adjust = () => {
            try {
                this.resizeTimer = 0;
                // try to adjust chart width
                let newWidth = this.domRef.current && this.domRef.current.offsetWidth > 100 ? this.domRef.current.offsetWidth : 100;
                if (newWidth !== this.state.chartAreaWidth) {
                    this.setState({chartAreaWidth: newWidth});
                }
            } catch (e) {
            }
        };

        if (this.resizeTimer === null) adjust();

        if (this.resizeTimer > 0) window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(adjust, 75);

    }

    requestReport() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const machineIds = this.props.machine ? [this.props.machine.machine_id] : null;

        // Check, if all data is set
        if (!dateFrom || !dateTill || !machineIds) return;

        const params = {
            // 'intervals', 'machine', 'start', 'end'
            machines: machineIds,
            companyId: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showMachineSwitchedOffStatus: true,
            shift: null,
            timezone: this.props.baseData.companies.currentCompany.timezone
        };

        const callback = function(res) {
            if (res && this.state.chartData === null) {
                this.setState({
                    chartData: res
                });
            }
        }.bind(this);

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return;

        this.setState({
            requestedParams: sParams
        });

        this.api.request('GetMachinePerformance', params, callback, null);

    }

    chartClick1(chartTarget, y, data) {

        // TODO message to parent

    }


    generateLegend(chartData) {

        if (!chartData && !this.state.requestedParams) return null;
        if (!chartData) return <LoadingSplash color={'dark'}/>;

        const tableRows = this.getTableRows(chartData);
        const rows = [];

        let totalSeconds = 0;

        for (let ix in chartData) {
            totalSeconds += chartData[ix]
        }

        if (totalSeconds <= 0) return null;

        for (let ix in tableRows) {
            let rowTemp = tableRows[ix];

            let row = (
                <tr key={'legend' + ix}>
                    <td>
                        <span style={{color: rowTemp.color}}>■</span>
                    </td>
                    <td>{rowTemp.statusName}</td>
                    <td style={{textAlign: 'right'}}>{rowTemp.pastTime}</td>
                    <td style={{color: rowTemp.color, textAlign: 'right'}}>{rowTemp.percentShare} %</td>
                </tr>
            );

            rows.push(row);
        }
    }

    getTableRows(chartData) {

        if (!chartData && !this.state.requestedParams) return null;
        if (!chartData) return <LoadingSplash color={'dark'} />;

        const states = MachineStates.getStates();
        const rows = [];

        let totalSeconds = 0;

        for (let ix in chartData) {
            totalSeconds += chartData[ix]
        }

        if (totalSeconds <= 0) return null;

        for (let ix in states) {
            let state = states[ix];
            let seconds = chartData[state.code];

            if (!seconds) continue;

            let pcnt = seconds / totalSeconds * 10000;

            pcnt = Math.round(pcnt);
            pcnt /= 100;

            let statusName = this.translate(ix);
            let formatedSeconds = StaticFunctions.convertSecondsToFormatedString(seconds);
            let percentShare = pcnt.toFixed(2);

            rows.push({statusName: statusName, pastTime: formatedSeconds, percentShare: percentShare, color: state.color});
        }

        return rows;

    }

    render() {

        if (!this.state.chartData || !this.state.chartData[0] || !this.state.chartAreaWidth) {
            return (
                <div className='display col-xs-12' ref={this.domRef}>
                    <LoadingSplash color={'dark'}/>
                </div>
            );
        }

        const chartDataStates = this.state.chartData[0].states;
        const legend = this.generateLegend(this.state.chartData);
        const header = this.props.header;
        const data = [];

        for (let ix in chartDataStates) {
            let state = chartDataStates[ix];

            let ms = MachineStates.get(ix);

            data.push({
                stateId: ix,
                value: state ? state : 0,
                color: ms ? ms.color : '#fff',
                name: ms ? this.translate(ms.translationKey) : ix
            })
        }

        return (
            <div ref={this.domRef} style={{textAlign: 'center'}}>
                <h4>{header}</h4>

                <ZSKPieChart
                    data={data}
                    translate={this.translate}
                    width={Math.round(this.state.chartAreaWidth * 0.5)}
                    height={this.props.height ? this.props.height : 250}
                    // handleClick={this.chartClick1}
                />
                <table>

                {legend}
                </table>
            </div>
        );

    }

}

export default PreviewReportMachinePerformance;
